<template>
    <el-tabs :class="getPrimaryColor" v-model="activeTab" @tab-click="changeTab(activeTab)">
        <el-tab-pane label="Sócios" name="0" />
        <el-tab-pane label="Procuradores" name="1" />
    </el-tabs>
</template>

<script>
export default {
    data() {
        return {
            activeTab: this.$store.state.tabs.partnerTab,
        }
    },
    methods: {
        changeTab(tab) {
            this.$store.commit('tabs/setPartnerTab', tab)
            this.$emit('update-tab', tab)
            return tab;
        }
    },
}
</script>

<style>

</style>
